define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var $flexibleGrids = $(".flexibleGrid");
        var flexibleGridColSelector = ".flexibleGrid_col";
        var $rahmenButton = $flexibleGrids.find(".readmore_button");
        var rahmenButtonVisibleContentSelector = "readmore_button--is-content-open";
        $rahmenButton.on("click", function (event) {
            var $button = $(event.target);
            $button.prev().slideToggle(Configuration_1.configuration.slideDownAnimationTimeInMs);
            if ($button.hasClass(rahmenButtonVisibleContentSelector)) {
                $button.text("Mehr lesen");
                $button.removeClass(rahmenButtonVisibleContentSelector);
            }
            else {
                $button.text("Details ausblenden");
                $button.addClass(rahmenButtonVisibleContentSelector);
            }
            event.preventDefault();
        });
        var initalViewport = $(window).width() || 0;
        $.each($flexibleGrids, function (index, parentObj) {
            var winWidth = $(window).width() || 0;
            var children = $(parentObj).find(flexibleGridColSelector);
            $.each(children, function (index, childObj) {
                if (winWidth < Configuration_1.configuration.breakpointMedium) {
                    if ($(childObj).hasClass("d-none")) {
                        childObj.remove();
                    }
                }
                else if (winWidth < Configuration_1.configuration.breakpointLarge) {
                    if ($(childObj).hasClass("d-md-none")) {
                        childObj.remove();
                    }
                }
                else {
                    if ($(childObj).hasClass("d-lg-none")) {
                        childObj.remove();
                    }
                }
            });
        });
        $(window).on("resize", function () {
            var winWidth = $(window).width() || 0;
            if (winWidth < Configuration_1.configuration.breakpointMedium) {
                //if (initalViewport >= configuration.breakpointMedium) location.reload();
            }
            else if (winWidth < Configuration_1.configuration.breakpointLarge) {
                //if (initalViewport < configuration.breakpointMedium || initalViewport >= configuration.breakpointLarge) location.reload();
            }
            else {
                //if (initalViewport < configuration.breakpointLarge) location.reload();
            }
        });
    });
});
